export const GENESYS_SYSTEM_KEY = 'Genesys';
